import { render, staticRenderFns } from "./lead_quickView.vue?vue&type=template&id=c33ae5be"
import script from "./lead_quickView.vue?vue&type=script&lang=js"
export * from "./lead_quickView.vue?vue&type=script&lang=js"
import style0 from "./lead_quickView.vue?vue&type=style&index=0&id=c33ae5be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports